/**
 * Created by vladislav on 11/01/2023
 */

const TileColorsEditorView = cleverapps.Layout.extend({
    ctor: function (tileColorsEditor) {
        let maxAmount = 0;
        while (bundles.card.frames[`skin_${maxAmount}`]) {
            maxAmount++;
        }

        const incDec = new IncDecBlock({
            value: tileColorsEditor.getCurrentValue(),
            range: [1, maxAmount],
            onChange: tileColorsEditor.setValue.bind(tileColorsEditor)
        });

        const styles = cleverapps.styles.TileColorsEditorView;

        // eslint-disable-next-line no-restricted-syntax
        const label = cleverapps.UI.generateTTFText("Colours:", cleverapps.styles.FONTS.EDITOR_BLUE_TEXT);
        this._super([label, incDec], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });

        tileColorsEditor.onChangeValue = this.createListener(() => {
            incDec._setValue(tileColorsEditor.getCurrentValue());
        });
    }
});

cleverapps.styles.TileColorsEditorView = {
    margin: 50
};